import { TRegisterEquipmentFormGroup } from 'src/app/core/services/register/register.service';

export interface EquipmentSAPRegistrationRequestDTO {
  company: string;
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  subRegion: string;
  phone: string;
  optIn?: boolean;
  serialNumber: string;
  placeOfPurchase: string;
  purchaseDate?: string;
  installDate: Date;
  source?: string;
  customerType?: string;
  language?: string;
  mobilePhone: boolean;
}

/**
 * Converts from a register equipment form group and a serial
 * to an object that fits the EquipmentSAPRegistrationRequestDTO interface
 * @param {TRegisterEquipmentFormGroup} registerEquipmentFormGroup
 * @param {string} serial
 * @param {string} country
 * @return {EquipmentSAPRegistrationRequestDTO}
 */
export function fromTRegisterEquipmentFormGroup(
  registerEquipmentFormGroup: TRegisterEquipmentFormGroup,
  serial: string,
  country: string
): EquipmentSAPRegistrationRequestDTO {
  return {
    company: registerEquipmentFormGroup.controls['businessName'].value!,
    country,
    email: registerEquipmentFormGroup.controls['businessEmail'].value!,
    firstName: registerEquipmentFormGroup.controls['representativeName'].value!,
    lastName:
      registerEquipmentFormGroup.controls['representativeLastName'].value!,
    installDate: registerEquipmentFormGroup.controls['installationDate'].value!,
    phone: registerEquipmentFormGroup.controls['primaryPhone'].value!,
    placeOfPurchase:
      registerEquipmentFormGroup.controls['placeOfPurchase'].value!,
    subRegion: registerEquipmentFormGroup.controls['stateOrRegion'].value!,
    mobilePhone:
      registerEquipmentFormGroup.controls['phoneType'].value! === 'mobile',
    serialNumber: serial,
  };
}
